import { DatabaseZap } from 'lucide-react'

import { defineModule } from '@/lib/module-routes'
import { EAUTOMATE_PERMISSIONS } from '@/lib/permissions'

import { eautomateApi } from './api/eautomate-api'
import { eautomateKeys } from './api/query-keys'
import { EAUTOMATE_DESCRIPTION } from './integration'
import { eautomateSettingsRoute } from './routes'

export const eautomateModule = defineModule({
  routes: [eautomateSettingsRoute],
  integrationCards: [
    {
      id: 'eautomate',
      name: 'e-automate',
      description: EAUTOMATE_DESCRIPTION,
      icon: DatabaseZap,
      order: 10,
      to: '/$entityId/settings/integrations/eautomate',
      readPermission: EAUTOMATE_PERMISSIONS.read,
      managePermission: EAUTOMATE_PERMISSIONS.manage,
      connectionCount: (entityId) => ({
        queryKey: [...eautomateKeys.connections(entityId), 'count'],
        queryFn: async () => (await eautomateApi.listConnections(entityId)).length,
      }),
    },
  ],
})
